<template>
  <section id="contents">
    <transition mode="out-in">
      <div class="card" v-if="entry">
        <div class="back">
          <button class="btn" @click="goBack()">
            <font-awesome-icon icon="arrow-left" />
          </button>
        </div>
        <div class="container">
          <div class="photo" v-if="entry.picture">
            <img :src="entry.picture" />
          </div>
          <div class="photo" v-else>
            <img src="../assets/logo.png" />
          </div>
          <div class="information">
            <div class="name">
              <h1>{{ entry.name }}</h1>
              <h4 v-if="entry.employer_name">{{ entry.employer_name }}</h4>
              <h4 v-if="entry.partner_name">{{ entry.partner_name }}</h4>
            </div>
            <div class="role">
              <h3 v-if="entry.role">{{ entry.role }}</h3>
              <h5 v-if="entry.role === 'Employer Contact'">{{ entry.employer_name }}</h5>
              <h5 v-if="entry.role === 'Partner'">{{ entry.partner_name }}</h5>
            </div>

            <div class="contact">
              <div class="phone" v-if="entry.phone">
                <h4>Phone</h4>
                <p>{{ entry.phone | formatPhone(this.entry.country) }}</p>
              </div>
              <div class="email" v-if="entry.email">
                <h4>Email</h4>
                <p>{{ entry.email }}</p>
              </div>
            </div>

            <div class="contact-info">
              <a :href="`tel:${entry.phone}`">
                <button class="btn call" v-if="entry.phone">
                  <font-awesome-icon icon="phone" />
                </button>
              </a>
              <a :href="`mailto:${entry.email}`" v-if="entry.email">
                <button class="btn mail">
                  <font-awesome-icon icon="envelope" />
                </button>
              </a>
              <a target="_blank" :href="`https://maps.google.com/?q=${address}`">
                <button class="btn route">
                  <font-awesome-icon icon="directions" />
                </button>
              </a>
            </div>

            <div class="address">
              <h4>Address</h4>
              <p>{{ entry.address }}</p>
              <p v-if="entry.address2">{{ entry.address2 }}</p>
              <p>
                {{ entry.city }}, {{ entry.stateCode || entry.state }} -
                {{ entry.zip }}
              </p>
              <p>{{ entry.country }}</p>
            </div>
          </div>
        </div>
      </div>
      <PageLoading v-else />
    </transition>
  </section>
</template>

<script>
import PageLoading from "@/components/PageLoading.vue";
import { api } from "@/services.js";

export default {
  name: "ContactCard",
  props: ["id"],
  components: {
    PageLoading
  },
  data() {
    return {
      entry: null
    };
  },
  computed: {
    address() {
      const address = [
        this.entry.address,
        this.entry.address2,
        this.entry.city,
        this.entry.state,
        this.entry.country
      ];
      return address.join(" ");
    }
  },
  methods: {
    pullData() {
      api.get("/directory/" + this.id).then(r => {
        this.entry = r.data;
      });
    },
    goBack() {
      window.history.back();
    }
  },
  created() {
    this.pullData();
  }
};
</script>

<style scoped>
.card {
  max-width: 600px;
  width: 100%;
  margin-top: 100px;
  background: #fff;
  box-shadow: 0 4px 8px rgba(30, 60, 90, 0.1);
  padding: 40px;
  position: relative;
}

.name {
  text-transform: capitalize;
}

.inactive {
  color: #cc1a1a;
  vertical-align: middle;
  margin: 2px 5px 0 0;
}

.photo img {
  position: relative;
  margin: -150px auto 0 auto;
  width: 150px;
  border-radius: 50%;
  box-shadow: 0 4px 8px rgba(30, 60, 90, 0.1);
}

.information {
  display: block;
  margin-top: 25px;
  text-align: center;
}

.role {
  padding-bottom: 20px;
}

.contact {
  padding-bottom: 20px;
  border-top: 1px solid rgba(30, 60, 90, 0.1);
  border-bottom: 1px solid rgba(30, 60, 90, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.contact-info {
  flex: 2;
  display: flex;
  justify-content: center;
  margin: 20px;
  padding: 40px;
  padding-top: 20px;
  border-bottom: 1px solid rgba(30, 60, 90, 0.1);
}

.contact-info button {
  padding: 11px 15px;
  margin: 0 5px;
  box-shadow: none;
  border-radius: 50%;
}

.contact-info button.call {
  background: rgb(104, 199, 104);
}

.contact-info button.mail {
  background: rgb(192, 64, 64);
}

.contact-info button.route {
  background: rgb(228, 167, 77);
}

.back button {
  background: #fff;
  color: #555;
}

.contact-info a {
  color: #fff;
}

@media only screen and (max-width: 767px) {
  .card {
    max-width: 350px;
    padding: 20px 15px;
  }

  .contact {
    flex-direction: column;
  }

  .photo img {
    margin: -125px auto 0 auto;
    width: 120px;
  }
}
</style>
